import React, { useState } from 'react'
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import CircleIcon from '@mui/icons-material/Circle';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ReactComponent as DownArrowIcon } from "../../../../../myfin_v2/assets/icons/down_arrow.svg";


const WorkspaceSettingAccordion = ({
	children,
	name,
	isEmpty,
	className = "",
	style = {},
	headerRight = null,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const isEmptyCheck = isEmpty ? isEmpty : false;

	return (
		<Accordion disableGutters elevation={0} sx={{ '&:before': { display: 'none' }, backgroundColor: "transparent", boxShadow: "none" }} className={className}>
			<AccordionSummary
				disableRipple
				expandIcon={<DownArrowIcon />}
				aria-controls="panel1-content"
				id="panel1-header"
				onClick={() => setIsOpen(!isOpen)}
				sx={{
					backgroundColor: "transparent !important",
					boxShadow: "none !important",
					outline: "none !important",
					"&.Mui-focusVisible": {
						backgroundColor: "transparent !important",
						outline: "none !important",
						boxShadow: "none !important",
					},
					"&.Mui-focused": {
						backgroundColor: "transparent !important",
						outline: "none !important",
						boxShadow: "none !important",
					},
					"&:focus": {
						backgroundColor: "transparent !important",
						outline: "none !important",
						boxShadow: "none !important",
					},
					"&:hover": {
						backgroundColor: "transparent !important",
					},
					"&.MuiAccordionSummary-root": {
						backgroundColor: "transparent !important",
					},
					"& .MuiAccordionSummary-content": {
						backgroundColor: "transparent !important",
					},
					"& .MuiAccordionSummary-content.Mui-focused": {
						backgroundColor: "transparent !important",
					},
				}}
				style={{
					borderBottom: isOpen ? "1px solid #EAEEED" : "none",
					minHeight: 0,
					height: 60,
					padding: "10px 16px",
					backgroundColor: "transparent",
					...style
				}}
			>
				<div className="d-flex align-items-center justify-content-between w-100" style={{ height: "100%", paddingRight: "10px" }}>
					<div className="ml-2 font-weight-500" style={{ fontSize: "16px", color: "#183930" }}>{name} </div>
					{isOpen && headerRight && (
						<div
							className="d-flex align-items-center"
							onClick={(e) => e.stopPropagation()}
						>
							{typeof headerRight === 'function' ? headerRight({ isOpen, setIsOpen }) : headerRight}
						</div>
					)}
				</div>
			</AccordionSummary>
			<AccordionDetails
				style={{
					padding: 0
				}}
			>
				{children}
			</AccordionDetails>
		</Accordion>
	)
	// return (
	//   <Accordion>
	//     <AccordionSummary className="p-1  w-100"
	//       expandIcon={<ExpandMoreIcon />}
	//       aria-controls="panel1-content"
	//       id="panel1-header"
	//       onClick={() => setIsOpen(!isOpen)}
	//     >
	//       <div className="d-flex align-items-center">
	//         {
	//           isEmptyCheck ? 
	//             <CircleIcon className="toggl-icon text-secondary ml-3" /> :
	//           isOpen ?
	//             <div className="open-radio-outer toggl-icon toggl-icon">
	//               <div className="open-radio-inner"></div>
	//             </div>
	//           :  <CheckCircleIcon className='ml-3' style={{ color: "#03565A" }} />
	//         }
	//         <div className="ml-2"> {name} </div>
	//       </div>
	//     </AccordionSummary>
	//     <AccordionDetails style={{ border: "2px solid #D6DBDF " }}>
	//       { children }
	//     </AccordionDetails>
	//   </Accordion>
	// )
}

export default WorkspaceSettingAccordion